import React from 'react'
import styled from "styled-components";
import { Select } from 'antd';
import { useHistory, useParams } from "react-router-dom";

const { Option } = Select;

const Container = styled.div`
  label{
      font-weight: bold;
  }  
`;

function DropDown(props) {

    const history = useHistory()
    const params = useParams()

    const handleChange = (value) => {
        if (!value) {
            history.push('/crm/wholesale')
        }

        history.push(`/crm/wholesale/${value}`)

    }

    return (
        <Container>
            <label>Buyers: </label>
            <Select value={params.status ?? ""} defaultValue="" style={{ width: 100 }} bordered={false} onChange={handleChange}>
                <Option value="">All</Option>
                <Option value="verified">Verified</Option>
                <Option value="pending">Pending</Option>
                <Option value="rejected">Rejected</Option>
                <Option value="blocked">Blocked</Option>
            </Select>
        </Container>
    )
}

DropDown.propTypes = {}

export default DropDown